<section class="contact-principal-mat-dialog">
  <div class="detail-card-header">
    <span whFlex class="w-h-header-icon-span">
      <i
        mat-card-avatar
        class="workheld-icons header-icon"
        [innerHtml]="userIcon"
      ></i>
    </span>
    <span whFlex class="w-h-header-span">
      <div class="single-header">
        {{ "workobject.ui.contactprincipal.header" | translate }}
      </div>
    </span>
  </div>
  <div class="contact-principal-mat-dialog-body">
    <form [formGroup]="contactPrincipalFormGroup">
      <div>
        <mat-form-field whFlex>
          <mat-label>{{
            "workobject.model.contactprincipal.message" | translate
          }}</mat-label>
          <textarea
            matInput
            placeholder="{{
              'workobject.model.contactprincipal.message' | translate
            }}"
            formControlName="message"
            [rows]="6"
          >
          </textarea>
        </mat-form-field>
      </div>
    </form>
  </div>
  <w-h-button-group align="end" mat-dialog-actions>
    <w-h-button
      [text]="'app.cancel.label' | translate | uppercase"
      matIcon="close"
      [disabled]="saving"
      (clicked)="cancel()"
    />
    <w-h-button
      [text]="'app.save.label' | translate | uppercase"
      matIcon="save"
      [isLoading]="saving"
      color="accent"
      type="flat"
      [disabled]="isFormGroupInvalid"
      (clicked)="createContactLog()"
    />
  </w-h-button-group>
</section>
